import { render, staticRenderFns } from "./AdminUserEdit.vue?vue&type=template&id=ca081ef0"
import script from "./AdminUserEdit.vue?vue&type=script&lang=js"
export * from "./AdminUserEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports